




































	import { Component, Vue, Mixins } from 'vue-property-decorator';
	import axios from 'axios'
	import { api } from '@/api'
	import Form from '@/mixins/form';

	@Component
	export default class PasswordForgotForm extends Mixins(Form)
	{
		public form: any = {
			email: null,
		}
		
		created(): void {
			this.form.email = this.$route.query.email || null
		}

		public submit(): void {

			if (!this.$refs.form.validate()) {
				this.loading = false;
                return;
			}
			
			this.loading = true;
			
			axios.post(api.path('v1.password.forgot'), this.form)
				.then( res => {
					this.$toast.success('An email with password reset instructions will be sent to your email address shortly.');
					this.$emit('success')
				})
				.finally(() => this.loading = false);
		}
	}
